import { Observable } from "rxjs";
import { Component, Inject, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { DiscoveryService } from "../discovery.service";
import { IClass } from "heracles/DataModel/IClass";
import { IHydraClient } from "hydraclient.js/types/src/IHydraClient";

@Component({
  selector: "hydra-documentation",
  templateUrl: "./hydra-documentation.component.html",
  styleUrls: ["./hydra-documentation.component.scss"]
})
export class HydraDocumentationComponent implements OnInit {
  public readonly selectedSupportedClass: Observable<IClass>;

  public constructor(
    @Inject(Router) private router: Router,
    @Inject(DiscoveryService) private discoveryService: DiscoveryService,
    @Inject("HydraClient") private hydraClient: IHydraClient) {
    this.selectedSupportedClass = this.discoveryService.selectedClass;
  }

  public makeLabelFor(resource: any): string {
    return this.discoveryService.makeLabelFor(resource) || this.discoveryService.makeLabelFor(resource.property);
  }

  public ngOnInit(): void {
    if (!this.discoveryService.isSelectedClassAvailable) {
      this.router.navigate(["/"]);
    }
  }
}
